import { Asset } from "../../squidex";
const cloneDeep = require('lodash.clonedeep');

export class AssetModel extends Asset {
  constructor(current?: Asset) {
      if (current) {
        super(cloneDeep(current) as Asset);
        } else {
            super({});
        }
    }
}
